import { useFormContext } from 'react-hook-form';
import styles from './adDetailsForms.module.scss';

interface IDpeFieldGroupProps extends IChildren {
  fieldName: string;
}

function DpeFieldGroup({ fieldName, children }: IDpeFieldGroupProps) {
  const {
    formState: { errors },
  } = useFormContext();

  const errorTxt = (errors[fieldName]?.message as string) ?? null;
  const hasError = Boolean(errorTxt);

  return (
    <div className={styles.dpeFieldGroup}>
      {children}
      {hasError && <p className={styles.errorMessage}>{errorTxt}</p>}
    </div>
  );
}

export default DpeFieldGroup;
